export default {
    state:{
        sidebarStateLeft: false,
        sidebarStateRight: false,
        showProfileActive: false,
    },
    mutations:{
        TOGGLE_SIDEBAR_LEFT(state, sidebarStateLeft) {
            state.sidebarStateLeft = sidebarStateLeft;
            if (state.sidebarStateLeft) state.sidebarStateRight = false
        },
        TOGGLE_SIDEBAR_RIGHT(state, sidebarStateRight) {
            state.sidebarStateRight = sidebarStateRight
            if (state.sidebarStateRight) state.sidebarStateLeft = false
        },
        SET_SHOW_PROFILE_ACTIVE(state, showProfileActive) {
            state.showProfileActive = showProfileActive;
        },
    },
    actions:{
        toggleSidebarLeft: ({commit}, sidebarState) => {
            commit('TOGGLE_SIDEBAR_LEFT', sidebarState);
        },
        toggleSidebarRight: ({commit}, sidebarState) => {
            commit('TOGGLE_SIDEBAR_RIGHT', sidebarState);
        },
        showProfileActive: ({commit}, params) => {
            commit('SET_SHOW_PROFILE_ACTIVE', params);
        },
    },
    getters:{
        sidebarStateLeft: state => {
            return state.sidebarStateLeft
        },
        sidebarStateRight: state => {
            return state.sidebarStateRight
        },
        showProfileActive: state => {
            return state.showProfileActive
        },

    }
}
